import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect,
  MultiSelect
} from 'vue-search-select';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination';
import MasterService from './../../../../masterdata/services/masterdata.service';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import CONSTANT from './../../../constants/constant'
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import XLSX from 'xlsx';
import Papa from "papaparse";
export default {
  name: 'services',
  components: {
    VueElementLoading,
    BasicSelect,
    DatePicker,
    Treeselect,
    CustomExpandableTable,
    Pagination,
  },
  props: ['selectedEdit', 'clientServiceData', 'callingFromClientContract', 'contractidd'],
  data: function() {
    return {
      zones:[],
      disabledPTL: true,
      disabled: true,
      clientcontract: 0,
      FTLPrePaid: '',
      FTLSurface: false,
      FTLForward: '',
      FTLReverse: '',
      FTLPay: '',
      FTLCredit: '',
      PTLPrePaid: '',
      PTLSurface: false,
      PTLAir: false,
      PTLForward: '',
      PTLReverse: '',
      PTLPay: '',
      PTLCredit: '',
      Air: '',
      Reverse: '',
      serviceLevelList: [],
      serviceLevelIdForFtlDownload:'',
      serviceLevelIdForPtlDownload:'',
      FTLBookingArray: [],
      FTLServiceArray: ["Forward"],
      accordiandata: [],
      opened: [],
      isLoading: false,
      PTLSurfServiceArray: ["Forward"],
      PTLAirServiceArray: ["Forward"],
      PTLSurfBookingArray: [],
      PTLAirBookingArray: [],
      loadaccordian: true,
      isServiceSelected: true,
      ftlerror: null,
      ptlerror: null,
      showbutton: true,
      LoaderForPrefill: false,
      selectedFtl:[],
      selectedPtl:[],
      surfServiceLevelList:[],
      airServiceLevelList:[],
      ServiceLevelDetailsForPTL:[],
      ServiceLevelDetailsForFTL:[],
      serviceleveldetailid: null,
      ftlObject:{
        "FTLSurfaceForward":{
          combination:{
            truckloadtype: "FTL",
            routemode: "Surface",
            servicetype: "Forward",
            bookingtype: [],
          },
          serviceLevel:{},
          serviceLevelList:[],
          UpdateSalesTatType:"ServiceLevelTemplate",
          filename:null,
          userreferencestring:"",
          offset: 0,
          isupload:0,
          isvalidated:0,
          totalrecords:0,
          validdatacount:0,
          invaliddatacount:0,
          currentPage: 1,
          pageLimit:CONSTANT.PER_PAGE_DATA,
          tableColumn: ['Sheet Row Number','Origin Region','Origin State','Origin City',
          'Destination Region','Destination State','Destination City',
          'Route Mode','E2E TAT','Invalid Reason'],
          tableItems:[],
          showSalesTatDownload: false,
          ischanged:null,
          tableColumnzonetozone: ['Origin Zone','Destination Zone',
          'TAT','Invalid Reason'],
          filenamezonetozone:null,
          isuploadzonetozone:0,
          isvalidatedzonetozone:0,
          totalrecordszonetozone:0,
          validdatacountzonetozone:0,
          invaliddatacountzonetozone:0,
          currentPagezonetozone: 1,
          tableItemszonetozone:[],
          showSalesTatDownloadzonetozone: false,
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:null,
          ischangedcitytocity:null,
          errorcitytocity: "",
          errorzonetozone:""
      
        },
        "FTLSurfaceReverse":{
          combination:{
            truckloadtype: "FTL",
            routemode: "Surface",
            servicetype: "Reverse",
            bookingtype: [],
          },
          serviceLevel:{},
          serviceLevelList:[],
          UpdateSalesTatType:"ServiceLevelTemplate",
          filename:null,
          userreferencestring:"",
          offset: 0,
          isupload:0,
          ischanged:0,
          isvalidated:0,
          totalrecords:0,
          validdatacount:0,
          invaliddatacount:0,
          currentPage: 1,
          pageLimit:CONSTANT.PER_PAGE_DATA,
          tableColumn: ['Sheet Row Number','Origin Region','Origin State','Origin City',
          'Destination Region','Destination State','Destination City',
          'Route Mode','E2E TAT','Invalid Reason'],
          tableItems:[],
          showSalesTatDownload: false,
          error: "",
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:null,
          tableColumnzonetozone: ['Origin Zone','Destination Zone',
          'TAT','Invalid Reason'],
          filenamezonetozone:null,
          isuploadzonetozone:0,
          isvalidatedzonetozone:0,
          totalrecordszonetozone:0,
          validdatacountzonetozone:0,
          invaliddatacountzonetozone:0,
          currentPagezonetozone: 1,
          tableItemszonetozone:[],
          showSalesTatDownloadzonetozone: false,
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:null,
          ischangedcitytocity:null,
          errorcitytocity: "",
          errorzonetozone:""
        },
      },
      ptlObject:{
        "PTLSurfaceForward":{
          combination:{
            truckloadtype: "PTL",
            routemode: "Surface",
            servicetype: "Forward",
            bookingtype: [],
          },
          serviceLevel:{},
          serviceLevelList:[],
          UpdateSalesTatType:"ServiceLevelTemplate",
          filename:null,
          userreferencestring:"",
          offset: 0,
          isupload:0,
          ischanged:0,
          isvalidated:0,
          totalrecords:0,
          validdatacount:0,
          invaliddatacount:0,
          currentPage: 1,
          pageLimit:CONSTANT.PER_PAGE_DATA,
          tableColumn: ['Sheet Row Number','Origin Region','Origin State','Origin City',
          'Destination Region','Destination State','Destination City',
          'Route Mode','E2E TAT','Invalid Reason'],
          tableItems:[],
          showSalesTatDownload: false,
          error: "",
          tableColumnzonetozone: ['Origin Zone','Destination Zone',
          'TAT','Invalid Reason'],
          filenamezonetozone:null,
          isuploadzonetozone:0,
          isvalidatedzonetozone:0,
          totalrecordszonetozone:0,
          validdatacountzonetozone:0,
          invaliddatacountzonetozone:0,
          currentPagezonetozone: 1,
          tableItemszonetozone:[],
          showSalesTatDownloadzonetozone: false,
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:null,
          ischangedcitytocity:null,
          errorcitytocity: "",
          errorzonetozone:""
        },
        "PTLSurfaceReverse":{
          combination:{
            truckloadtype: "PTL",
            routemode: "Surface",
            servicetype: "Reverse",
            bookingtype: [],
          },
          serviceLevel:{},
          serviceLevelList:[],
          UpdateSalesTatType:"ServiceLevelTemplate",
          filename:null,
          userreferencestring:"",
          offset: 0,
          isupload:0,
          ischanged:0,
          isvalidated:0,
          totalrecords:0,
          validdatacount:0,
          invaliddatacount:0,
          currentPage: 1,
          pageLimit:CONSTANT.PER_PAGE_DATA,
          tableColumn: ['Sheet Row Number','Origin Region','Origin State','Origin City',
          'Destination Region','Destination State','Destination City',
          'Route Mode','E2E TAT','Invalid Reason'],
          tableItems:[],
          showSalesTatDownload: false,
          error: "",
          tableColumnzonetozone: ['Origin Zone','Destination Zone',
          'TAT','Invalid Reason'],
          filenamezonetozone:null,
          isuploadzonetozone:0,
          isvalidatedzonetozone:0,
          totalrecordszonetozone:0,
          validdatacountzonetozone:0,
          invaliddatacountzonetozone:0,
          currentPagezonetozone: 1,
          tableItemszonetozone:[],
          showSalesTatDownloadzonetozone: false,
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:null,
          ischangedcitytocity:null,
          errorcitytocity: "",
          errorzonetozone:""
        },
        "PTLAirForward":{
          combination:{
            truckloadtype: "PTL",
            routemode: "Air",
            servicetype: "Forward",
            bookingtype: [],
          },
          serviceLevel:{},
          serviceLevelList:[],
          UpdateSalesTatType:"ServiceLevelTemplate",
          filename:null,
          userreferencestring:"",
          offset: 0,
          isupload:0,
          ischanged:0,
          isvalidated:0,
          totalrecords:0,
          validdatacount:0,
          invaliddatacount:0,
          currentPage: 1,
          pageLimit:CONSTANT.PER_PAGE_DATA,
          tableColumn: ['Sheet Row Number','Origin Region','Origin State','Origin City',
          'Destination Region','Destination State','Destination City',
          'Route Mode','E2E TAT','Invalid Reason'],
          tableItems:[],
          showSalesTatDownload: false,
          error: "",
          tableColumnzonetozone: ['Origin Zone','Destination Zone',
          'TAT','Invalid Reason'],
          filenamezonetozone:null,
          isuploadzonetozone:0,
          isvalidatedzonetozone:0,
          totalrecordszonetozone:0,
          validdatacountzonetozone:0,
          invaliddatacountzonetozone:0,
          currentPagezonetozone: 1,
          tableItemszonetozone:[],
          showSalesTatDownloadzonetozone: false,
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:null,
          ischangedcitytocity:null,
          errorcitytocity: "",
          errorzonetozone:""
        },
        "PTLAirReverse":{
          combination:{
            truckloadtype: "PTL",
            routemode: "Air",
            servicetype: "Reverse",
            bookingtype: [],
          },
          serviceLevel:{},
          serviceLevelList:[],
          UpdateSalesTatType:"ServiceLevelTemplate",
          filename:null,
          userreferencestring:"",
          offset: 0,
          isupload:0,
          ischanged:0,
          isvalidated:0,
          totalrecords:0,
          validdatacount:0,
          invaliddatacount:0,
          currentPage: 1,
          pageLimit:CONSTANT.PER_PAGE_DATA,
          tableColumn: ['Sheet Row Number','Origin Region','Origin State','Origin City',
          'Destination Region','Destination State','Destination City',
          'Route Mode','E2E TAT','Invalid Reason'],
          tableItems:[],
          showSalesTatDownload: false,
          error: "",
          tableColumnzonetozone: ['Origin Zone','Destination Zone',
          'TAT','Invalid Reason'],
          filenamezonetozone:null,
          isuploadzonetozone:0,
          isvalidatedzonetozone:0,
          totalrecordszonetozone:0,
          validdatacountzonetozone:0,
          invaliddatacountzonetozone:0,
          currentPagezonetozone: 1,
          tableItemszonetozone:[],
          showSalesTatDownloadzonetozone: false,
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:null,
          ischangedcitytocity:null,
          errorcitytocity: "",
          errorzonetozone:""
        },
      },
      airServiceLevelListZonetoZone:[],
      surfServiceLevelListZonetoZone:[],
      surfServiceLevelListCitytoCity:[],
      airServiceLevelListZonetoZone:[],
      airServiceLevelListCitytoCity:[],
      userid:"",
      userreferencestring: "",
      // servicetype : null,
     ServiceTypeDropdown : [
                {
                    id : 1,
                    label : 'City To City',
                },
                {
                    id : 2,
                    label : 'Zone To Zone'
                }
            ],
            isinvalid:false
    }
  },
  computed: {
  },
  async mounted() {
    if (this.selectedEdit.view == true) {
      this.showbutton = false;
    }
    if(this.callingFromClientContract){
      this.clientcontract = 1;
    }
    await this.getServiceLevelDropdown()
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.userid = userdetail.userid;

    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let text = "";
    for (let i = 0; i < 3; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    let uniquerefno = this.userid+text;
    this.userreferencestring = uniquerefno;

    this.$nextTick(() => {
      if (this.selectedEdit.length == 0) {
        this.actionType = "ADD"
        if(this.contractidd){
          this.actionType = "EDIT";
          this.contractid = this.contractidd;
          this.getServicesDetails(this.contractid, 'ClientContract')
        }
      } else {
        this.actionType = "EDIT"
        if (this.selectedEdit.contracttemplateid) {
          this.contractid = this.selectedEdit.id
        } else {
          this.contractid = this.selectedEdit.id
        }
        if(this.contractidd){
          this.contractid = this.contractidd;
        }
        this.getServicesDetails(this.contractid, 'ClientContract')
      }
    })
    await this.getZonenamesdata()
  },
  methods: {
    check() {
      if (this.actionType == "EDIT") {
        this.getServicesDetails(this.contractid)
      }
    },
    onChangeUpdateSalesTatType(servicetype, servicekey){
        if(servicetype=="ftl" && this.ftlObject[servicekey].UpdateSalesTatType=="FileUpload"){
          if (this.ftlObject[servicekey].servicetypezonetozonecitytocity==1) {
            this.ftlObject[servicekey].showSalesTatDownload = false;
          }
          else{
            this.ftlObject[servicekey].showSalesTatDownloadzonetozone = false;
          }
          this.ftlObject[servicekey].serviceLevel = {};
          this.ftlObject[servicekey].error = "";
          this.ftlObject[servicekey].ischanged = 1;
        }
        if(servicetype=="ptl" && this.ptlObject[servicekey].UpdateSalesTatType=="FileUpload"){
          this.ptlObject[servicekey].serviceLevel = {};
          this.ptlObject[servicekey].error = "";
          if (this.ptlObject[servicekey].servicetypezonetozonecitytocity==1) {
            this.ptlObject[servicekey].showSalesTatDownload = false;
          }
          else{
            this.ptlObject[servicekey].showSalesTatDownloadzonetozone = false;
          }
          this.ptlObject[servicekey].ischanged = 1;
        }
        if(servicetype=="ftl" && this.ftlObject[servicekey].UpdateSalesTatType=="ServiceLevelTemplate"){
          this.ftlObject[servicekey].filename = null;
          this.ftlObject[servicekey].isupload = 0;
          this.ftlObject[servicekey].isvalidated = 0;
          if (this.ftlObject[servicekey].servicetypezonetozonecitytocity==1) {
            this.ftlObject[servicekey].showSalesTatDownload = false;
          }
          else{
            this.ftlObject[servicekey].showSalesTatDownloadzonetozone = false;
          }
          this.ftlObject[servicekey].ischanged = 1;
          this.ftlObject[servicekey].error = "";
        }
        if(servicetype=="ptl" && this.ptlObject[servicekey].UpdateSalesTatType=="ServiceLevelTemplate"){
          this.ptlObject[servicekey].filename = null;
          this.ptlObject[servicekey].isupload = 0;
          this.ptlObject[servicekey].isvalidated = 0;
          if (this.ptlObject[servicekey].servicetypezonetozonecitytocity==1) {
            this.ptlObject[servicekey].showSalesTatDownload = false;
          }
          else{
            this.ptlObject[servicekey].showSalesTatDownloadzonetozone = false;
          }
          this.ptlObject[servicekey].ischanged = 1;
          this.ptlObject[servicekey].error = "";
        }
    },
    async chooseFile(e,servicetype,servicekey,servicetypezonetozonecitytocity){
      try {
        if(servicetype=="ftl"){
          this.ftlObject[servicekey].isupload = 0;
          this.ftlObject[servicekey].ischanged = 1;
          this.ftlObject[servicekey].isvalidated = 0;
          this.ftlObject[servicekey].showSalesTatDownload = false;
          this.ftlObject[servicekey].error = "";
        }else{
          this.ptlObject[servicekey].isupload = 0;
          this.ptlObject[servicekey].ischanged = 1;
          this.ptlObject[servicekey].isvalidated = 0;
          this.ptlObject[servicekey].showSalesTatDownload = false;
          this.ptlObject[servicekey].error = "";
        }
        const files = e.target.files;
        if (!files.length) {
          this.$refs.files.value=null;
          return;
        } else if (!/\.(csv)$/.test(files[0].name.toLowerCase())) {
          this.$refs.files.value=null;
          return this.$alert('The upload format is incorrect. Please upload csv format', "", "error");
        }else{
          if(servicetype=="ftl"){
            this.ftlObject[servicekey].filename = e.target.files[0].name;
          }else{
            this.ptlObject[servicekey].filename = e.target.files[0].name;
          }
          await this.parseFile(servicetype,servicekey,e.target.files[0],servicetypezonetozonecitytocity);
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async parseFile(servicetype,servicekey,filedata,servicetypezonetozonecitytocity){
      let userid = this.userid;
      let userreferencestring = this.userreferencestring+servicekey;
      var count = 0; // cache the running count
      var csvData=[];
      var sheetid = 1;
      var validheader = 1;
      Papa.parse( filedata, {
          header: true,
          skipEmptyLines: true,
          before: this.isLoading = true,
          worker: true, // Don't bog down the main thread if its a big file
          step: function(result) {
            let fileHeaders = result.meta.fields;
            if(sheetid==1 && !fileHeaders.includes("Origin Region") ||
              !fileHeaders.includes("Origin State") ||
              !fileHeaders.includes("Origin City") ||
              !fileHeaders.includes("Destination Region") ||
              !fileHeaders.includes("Destination State") ||
              !fileHeaders.includes("Destination City") ||
              !fileHeaders.includes("Route Mode") ||
              !fileHeaders.includes("E2E TAT")){
                if(servicetype=="ftl"){
                  this.ftlObject[servicekey].filename = null;
                }else{
                  this.ptlObject[servicekey].filename = null;
                }
                validheader = 0;
            }
            sheetid ++;
            let tempResult = {};
              tempResult.originregion = (result.data['Origin Region'])?result.data['Origin Region']:null;
              tempResult.originstate = (result.data['Origin State'])?result.data['Origin State']:null;
              tempResult.origincity = (result.data['Origin City'])?result.data['Origin City']:null;
              tempResult.destinationregion = (result.data['Destination Region'])?result.data['Destination Region']:null;
              tempResult.destinationstate = (result.data['Destination State'])?result.data['Destination State']:null;
              tempResult.destinationcity = (result.data['Destination City'])?result.data['Destination City']:null;
              tempResult.travelmode = (result.data['Route Mode'])?result.data['Route Mode']:null;
              tempResult.feedertat = (result.data['E2E TAT'])?result.data['E2E TAT']:null;
              tempResult.status = 0;
              tempResult.userid = userid;
              tempResult.userreferencestring = userreferencestring;
              tempResult.sheetid = sheetid;
              tempResult.servicetype = 1;
              csvData.push(tempResult);
          }.bind(this),
          complete: function(){
            if(validheader==0){
              this.isLoading = false;
              if(servicetype=="ftl"){
                this.ftlObject[servicekey].filename = null;
              }else{
                this.ptlObject[servicekey].filename = null;
              }
              return this.$alert('File headers are not matched. Please download OPS TAT csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
            }else if(csvData.length<1){
              this.isLoading = false;
              if(servicetype=="ftl"){
                this.ftlObject[servicekey].filename = null;
              }else{
                this.ptlObject[servicekey].filename = null;
              }
              return this.$alert('Sales TAT file data should not be blank. At least one record set is required.', "", "error");
            }else{
              if(servicetype=="ftl"){
                this.ftlObject[servicekey].totalrecords = csvData.length;
                this.ftlObject[servicekey].isupload = 1;
                this.ftlObject[servicekey].isvalidated = 0;
              }else{
                this.ptlObject[servicekey].totalrecords = csvData.length;
                this.ptlObject[servicekey].isupload = 1;
                this.ptlObject[servicekey].isvalidated = 0;
              }
              this.chunkArray(csvData, 20000,userreferencestring,servicetypezonetozonecitytocity);
            }
          }.bind(this)
      } );
      this.isLoading = false
    },
    async chunkArray(myArray, chunk_size,userreferencestring,servicetype){
      try {
        console.log("Start Time", Date() );
        await this.deletePreviousUploadSalesTAT(userreferencestring,servicetype);
        var index = 0;
        var arrayLength = myArray.length;
        let tempArr = [];
        for (index = 0; index < arrayLength; index += chunk_size) {
            let myChunk = myArray.slice(index, index+chunk_size);
            await this.uploadSalesFile(myChunk, index);
        }
        console.log("End Time", Date() );
        this.$alertify.success("File data uploaded Successfully");
        this.isLoading = false;
      }catch (err){
        console.log(err);
      }
    },
    async deletePreviousUploadSalesTAT(userreferencestring,servicetype){
      try{
        this.isLoading = true;
        var inputPayload = {};
        inputPayload.userid = this.userid;
        if(servicetype)
        {
          inputPayload.servicetype=servicetype
        }
        inputPayload.userreferencestring = userreferencestring;
        let result = await MasterService.deletePreviousUploadSalesTAT(inputPayload);
      } catch(err){
        console.log(err);
      }
    },
    async uploadSalesFile(filechunkdata, index){
      try{
        var inputPayload = {};
        inputPayload.file = filechunkdata;
        let result = await MasterService.uploadSalesTAT(inputPayload);
      } catch(err){
        console.log(err);
      }
    },
    async validateFile(servicetype,servicekey){
      try {
        this.isLoading = true;
        let routemode;
        if(servicekey.includes("Surface")){
          routemode = "Surface";
        }else{
          routemode = "Air";
        }

        var inputPayload = {};
        inputPayload.routemode = routemode;
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring+servicekey;
        let result = await MasterService.validateSalesTAT(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          let resultData = result.data.data;
          let successCount = 0;
          let failedCount = 0;
          resultData.forEach((element) => {
              if(element.status==1){
                successCount = element.count;
              }
              if(element.status==2){
                failedCount = element.count;
              }
          });
          if(servicetype=='ftl'){
            this.ftlObject[servicekey].isvalidated = 1;
            this.ftlObject[servicekey].validdatacount = successCount;
            this.ftlObject[servicekey].invaliddatacount = failedCount;
            this.ftlObject[servicekey].userreferencestring = this.userreferencestring+servicekey;
            this.ftlObject[servicekey].error = "";
            if(this.ftlObject[servicekey].invaliddatacount > 0){
              this.getInvalidDataListing(servicetype,servicekey);
            }
          }else{
            this.ptlObject[servicekey].isvalidated = 1;
            this.ptlObject[servicekey].validdatacount = successCount;
            this.ptlObject[servicekey].invaliddatacount = failedCount;
            this.ptlObject[servicekey].userreferencestring = this.userreferencestring+servicekey;
            this.ptlObject[servicekey].error = "";
            if(this.ptlObject[servicekey].invaliddatacount > 0){
              this.getInvalidDataListing(servicetype,servicekey);
            }
          }
        }else{
          if(servicetype=='ftl'){
            this.ftlObject[servicekey].isupload = 0;
            this.ftlObject[servicekey].isvalidated = 0;
            this.ftlObject[servicekey].validdatacount = 0;
            this.ftlObject[servicekey].invaliddatacount = 0;
            this.ftlObject[servicekey].userreferencestring = "";
            this.ftlObject[servicekey].error = "";
          }else{
            this.ptlObject[servicekey].isupload = 0;
            this.ptlObject[servicekey].isvalidated = 0;
            this.ptlObject[servicekey].validdatacount = 0;
            this.ptlObject[servicekey].invaliddatacount = 0;
            this.ptlObject[servicekey].userreferencestring = "";
            this.ptlObject[servicekey].error = "";
          }
          this.$alert(result.data.message,"", "error");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getInvalidDataListing(servicetype,servicekey){
      try {
        this.isLoading = true;
        let offset;
        let pageLimit;

        if(servicetype=="ftl"){
          offset = this.ftlObject[servicekey].offset;
          pageLimit = this.ftlObject[servicekey].pageLimit;
        }else{
          offset = this.ptlObject[servicekey].offset;
          pageLimit = this.ptlObject[servicekey].pageLimit;
        }

        let inputPayload = {
          "offset": offset,
          "limit": pageLimit,
        }
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring+servicekey;

        let result = await MasterService.getInvalidSalesTATListing(inputPayload);
        if(servicetype=="ftl"){
          this.ftlObject[servicekey].totalCount = result.data.data.count;
          this.ftlObject[servicekey].totalPage = Math.ceil(this.ftlObject[servicekey].totalCount/this.ftlObject[servicekey].pageLimit);
          this.ftlObject[servicekey].tableItems = result.data.data.rows.map((el)=>{
            return {
              'id':el.id,
              'Sheet Row Number':el.sheetid,
              'Origin Region':el.originregion,
              'Origin State': el.originstate,
              'Origin City':el.origincity,
              'Destination Region':el.destinationregion,
              'Destination State':el.destinationstate,
              'Destination City':el.destinationcity,
              'Route Mode':el.travelmode,
              'E2E TAT':el.feedertat,
              'Invalid Reason':el.comment
            }
          });
        }else{
          this.ptlObject[servicekey].totalCount = result.data.data.count;
          this.ptlObject[servicekey].totalPage = Math.ceil(this.ptlObject[servicekey].totalCount/this.ptlObject[servicekey].pageLimit);
          this.ptlObject[servicekey].tableItems = result.data.data.rows.map((el)=>{
            return {
              'id':el.id,
              'Sheet Row Number':el.sheetid,
              'Origin Region':el.originregion,
              'Origin State': el.originstate,
              'Origin City':el.origincity,
              'Destination Region':el.destinationregion,
              'Destination State':el.destinationstate,
              'Destination City':el.destinationcity,
              'Route Mode':el.travelmode,
              'E2E TAT':el.feedertat,
              'Invalid Reason':el.comment
            }
          });
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    async downloadInvalidData(servicekey){
      try {
        this.isLoading = true;
        let inputPayload = {}
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring+servicekey;
        let result = await MasterService.getInvalidSalesTATForDownload(inputPayload);
        let invaliddataResult = result.data.data.rows;
        let tempData = [];
        invaliddataResult.forEach((item)=>{
          tempData.push({
               "Sheet Row Number": item.sheetid,
               "Origin Region":item.originregion,
               "Origin State":item.originstate,
               "Origin City":item.origincity,
               "Destination Region":item.destinationregion,
               "Destination State":item.destinationstate,
               "Destination City":item.destinationcity,
               "Route Mode":item.travelmode,
               "E2E TAT":item.feedertat,
               "Invalid Reason": item.comment
             });
        });

        var blob = new Blob([Papa.unparse(tempData)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'Invalid Sales TAT.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    onPageChange(page,servicetype,servicekey) {
      if(servicetype=="ftl"){
        this.ftlObject[servicekey].currentPage = page;
        this.ftlObject[servicekey].offset = (page - 1) *this.ftlObject[servicekey].pageLimit;
      }else{
        this.ptlObject[servicekey].currentPage = page;
        this.ptlObject[servicekey].offset = (page - 1) *this.ptlObject[servicekey].pageLimit;
      }
      this.getInvalidDataListing(servicetype,servicekey);
    },
    async getServicesDetails(contractid, parent) {
      try {
        this.LoaderForPrefill = true
        let payload = {
          contractid: contractid
        }
        let result
        if (this.callingFromClientContract && this.callingFromClientContract.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
          if (this.callingFromClientContract.newlySelectedTemplateId && !this.contractidd) {
            result = await MasterService.getServicesDetailsforView(payload)
            console.log("******From Service Master*********")
          } else if (this.callingFromClientContract.existingContractTemplateId || this.contractidd) {
            payload.contractid = this.callingFromClientContract.id;
            result = await ClientService.getClientServicesDetailsforView(payload)
            //from Existing Client service details
            console.log("******Client service details*********");
          }
        }
         else {
          console.log("******service Master details*********");
          result = await MasterService.getServicesDetailsforView(payload)
        }
        var data = result.data.data
        var ftldata = []
        var ptldata = []
        for (var i = 0; i < data.contractmasterservices.length; i++) {
          var servicelevel
          var serviceleveldetail = []
          var contractservicesid ;
          let uploadadditionalcities=0
          let processedData = data.contractmasterservicelevel.filter(value =>{
            if (data.contractmasterservices[i].id == value.contractservicesid ) {
              return value
            }
          })
          for (var j = 0; j < data.contractmasterservicelevel.length; j++) {
            if(processedData.length==2)
            {
              if ((data.contractmasterservices[i].id == data.contractmasterservicelevel[j].contractservicesid || data.contractmasterservices[i].id == data.contractmasterservicelevel[j].clientcontractservicesid) && data.contractmasterservicelevel[j].servicetype==2 ) {
                servicelevel = data.contractmasterservicelevel[j].servicelevelid;
                contractservicesid = data.contractmasterservices[i].id;
              }
              uploadadditionalcities=1
            }
            else{
              if (data.contractmasterservices[i].id == data.contractmasterservicelevel[j].contractservicesid || data.contractmasterservices[i].id == data.contractmasterservicelevel[j].clientcontractservicesid ) {
                servicelevel = data.contractmasterservicelevel[j].servicelevelid;
                contractservicesid = data.contractmasterservices[i].id;
              }
            }
          }
          let serviceareatype
          if (data.contractmasterservices[i].serviceareatype) {
            serviceareatype = data.contractmasterservices[i].serviceareatype
          }
          if (data.contractmasterservices[i].truckloadtype == 'FTL') {
            ftldata.push({
              key: "FTL"+data.contractmasterservices[i].routemode+data.contractmasterservices[i].servicetype,
              routemode: data.contractmasterservices[i].routemode,
              servicetype: data.contractmasterservices[i].servicetype,
              bookingtype: data.contractmasterservices[i].bookingtype,
              servicelevelid: servicelevel,
              serviceleveldetail: serviceleveldetail,
              contractservicesid: contractservicesid,
              servicetypezonetozonecitytocity:serviceareatype,
              uploadadditionalcities:uploadadditionalcities
            })
          } else {
            ptldata.push({
              key: "PTL"+data.contractmasterservices[i].routemode+data.contractmasterservices[i].servicetype,
              routemode: data.contractmasterservices[i].routemode,
              servicetype: data.contractmasterservices[i].servicetype,
              bookingtype: data.contractmasterservices[i].bookingtype,
              servicelevelid: servicelevel,
              serviceleveldetail: serviceleveldetail,
              contractservicesid: contractservicesid,
              servicetypezonetozonecitytocity:serviceareatype,
              uploadadditionalcities:uploadadditionalcities
            })
          }
        }
        this.editdata = {
          contractid: this.contractid,
          contractname: data.contracttemplatename,
          contractdetail: {
            ftldata: ftldata,
            ptldata: ptldata
          }
        }
        this.$nextTick(() => {
          this.preFillContractServiceData(this.editdata)
        })
      } catch (err) {
        this.LoaderForPrefill = false;
        console.log(err);
      }
    },
    async preFillContractServiceData(editdata) {
      try {
        this.FTLBookingArray = [];
        this.PTLSurfBookingArray = [];
        this.PTLAirBookingArray = [];
        this.loadtab = 'PTL'
        for (let i = 0; i < editdata.contractdetail.ptldata.length; i++) {
          if (editdata.contractdetail.ptldata[i].routemode == "Surface") {
            this.PTLSurface = true
            if (this.PTLSurfServiceArray.indexOf(editdata.contractdetail.ptldata[i].servicetype) == -1) {
              this.PTLSurfServiceArray.push(editdata.contractdetail.ptldata[i].servicetype)
            }
            if (this.PTLSurfBookingArray.indexOf(editdata.contractdetail.ptldata[i].bookingtype) == -1) {
              this.PTLSurfBookingArray = editdata.contractdetail.ptldata[i].bookingtype
            }
          } else if (editdata.contractdetail.ptldata[i].routemode == "Air") {
            this.PTLAir = true
            if (this.PTLAirServiceArray.indexOf(editdata.contractdetail.ptldata[i].servicetype) == -1) {
              this.PTLAirServiceArray.push(editdata.contractdetail.ptldata[i].servicetype)
            }
            if (this.PTLAirBookingArray.indexOf(editdata.contractdetail.ptldata[i].bookingtype) == -1) {
              this.PTLAirBookingArray = editdata.contractdetail.ptldata[i].bookingtype
            }
          }
          if (editdata.contractdetail.ptldata[i].servicetypezonetozonecitytocity && editdata.contractdetail.ptldata[i].servicetypezonetozonecitytocity==1) {
            this.ptlObject[editdata.contractdetail.ptldata[i].key].showSalesTatDownload = true;
          }
          else{
            this.ptlObject[editdata.contractdetail.ptldata[i].key].showSalesTatDownloadzonetozone = true;
          }
          this.ptlObject[editdata.contractdetail.ptldata[i].key].ischanged = 0;

          if(this.clientcontract==0){
            this.ptlObject[editdata.contractdetail.ptldata[i].key].UpdateSalesTatType = "ServiceLevelTemplate";
          }else if(editdata.contractdetail.ptldata[i].servicelevelid){
            this.ptlObject[editdata.contractdetail.ptldata[i].key].UpdateSalesTatType = "ServiceLevelTemplate";
          }else{
            this.ptlObject[editdata.contractdetail.ptldata[i].key].UpdateSalesTatType = "FileUpload";
          }
          if (editdata.contractdetail.ptldata[i].servicetypezonetozonecitytocity) {
            this.ptlObject[editdata.contractdetail.ptldata[i].key].servicetypezonetozonecitytocity = editdata.contractdetail.ptldata[i].servicetypezonetozonecitytocity
          }
          if (editdata.contractdetail.ptldata[i].uploadadditionalcities == 1) {
            this.ptlObject[editdata.contractdetail.ptldata[i].key].uploadadditionalcities = 1
          }
          else {
            this.ptlObject[editdata.contractdetail.ptldata[i].key].uploadadditionalcities = 0
          }
          this.ptlObject[editdata.contractdetail.ptldata[i].key].serviceLevel.id = (editdata.contractdetail.ptldata[i].servicelevelid)?editdata.contractdetail.ptldata[i].servicelevelid:null;
          this.serviceLevelIdForPtlDownload = this.ptlObject[editdata.contractdetail.ptldata[i].key].serviceLevel.id;
          this.ptlObject[editdata.contractdetail.ptldata[i].key].contractservicesid = editdata.contractdetail.ptldata[i].contractservicesid;
        }
        this.loadtab = 'FTL'
        for (var i = 0; i < editdata.contractdetail.ftldata.length; i++) {
          this.FTLSurface = true
          if (this.FTLServiceArray.indexOf(editdata.contractdetail.ftldata[i].servicetype) == -1) {
            this.FTLServiceArray.push(editdata.contractdetail.ftldata[i].servicetype)
          }
          if (this.FTLBookingArray.indexOf(editdata.contractdetail.ftldata[i].bookingtype) == -1) {
            this.FTLBookingArray = editdata.contractdetail.ftldata[i].bookingtype
          }
          if (editdata.contractdetail.ftldata[i].servicetypezonetozonecitytocity && editdata.contractdetail.ftldata[i].servicetypezonetozonecitytocity==1) {
            this.ftlObject[editdata.contractdetail.ftldata[i].key].showSalesTatDownload = true;
          }
          else{
            this.ftlObject[editdata.contractdetail.ftldata[i].key].showSalesTatDownloadzonetozone = true;
          }
          this.ftlObject[editdata.contractdetail.ftldata[i].key].ischanged = 0;

          if(this.clientcontract==0){
            this.ftlObject[editdata.contractdetail.ftldata[i].key].UpdateSalesTatType = "ServiceLevelTemplate";
          }else if(editdata.contractdetail.ftldata[i].servicelevelid){
            this.ftlObject[editdata.contractdetail.ftldata[i].key].UpdateSalesTatType = "ServiceLevelTemplate";
          }else{
            this.ftlObject[editdata.contractdetail.ftldata[i].key].UpdateSalesTatType = "FileUpload";
          }
          if (editdata.contractdetail.ftldata[i].servicetypezonetozonecitytocity) {
            this.ftlObject[editdata.contractdetail.ftldata[i].key].servicetypezonetozonecitytocity = editdata.contractdetail.ftldata[i].servicetypezonetozonecitytocity
          }
          if (editdata.contractdetail.ftldata[i].uploadadditionalcities == 1) {
            this.ftlObject[editdata.contractdetail.ftldata[i].key].uploadadditionalcities = 1
          }
          else {
            this.ftlObject[editdata.contractdetail.ftldata[i].key].uploadadditionalcities = 0
          }
          this.ftlObject[editdata.contractdetail.ftldata[i].key].serviceLevel.id = (editdata.contractdetail.ftldata[i].servicelevelid)?editdata.contractdetail.ftldata[i].servicelevelid:null;
          this.serviceLevelIdForFtlDownload = this.ftlObject[editdata.contractdetail.ftldata[i].key].serviceLevel.id;
          this.ftlObject[editdata.contractdetail.ftldata[i].key].contractservicesid = editdata.contractdetail.ftldata[i].contractservicesid;
        }
        this.createAccordianDataForPTL();
        this.createAccordianDataForFTL();
        this.LoaderForPrefill = false;
      } catch (err) {
        this.LoaderForPrefill = false;
        console.log(err);
      }
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-blue']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    changeTab(tab) {
      this.opened = []
      this.loadtab = tab
      if (tab == 'FTL') {
        this.createAccordianDataForFTL()
      } else {
        this.createAccordianDataForPTL()
      }
    },
    chkFTLRouteMode() {
      if (this.FTLSurface == true) {
        this.disabled = false;
      } else {
        this.FTLBookingArray = []
        this.disabled = true;
        for (var k in this.ftlObject) {
            this.ftlObject[k].isSelected = false
        }
      }
      this.createAccordianDataForFTL()
    },
    chkPTLrouteModeSurface() {
      if (this.PTLSurface == true) {
        this.disabledPTL = false;
      } else {
        this.PTLSurfBookingArray = []
        this.disabledPTL = true;
        for (var k in this.ptlObject) {
          if(this.ptlObject[k].combination.routemode == "Surface") {
            this.ptlObject[k].isSelected = false
          }
        }
      }
      this.createAccordianDataForPTL()
    },
    chkPTLrouteModeAir() {
      if (this.PTLAir == true) {
        this.disabledPTL = false;
      } else {
        this.disabledPTL = true;
        this.PTLAirBookingArray = []
        for (var k in this.ptlObject) {
          if(this.ptlObject[k].combination.routemode == "Air") {
            this.ptlObject[k].isSelected = false
          }
        }
      }
      this.createAccordianDataForPTL()
    },
    createAccordianDataForFTL() {
      this.accordiandata = []
      let tempBookingArr = []
      this.FTLBookingArray.forEach((item) => {
        let type = CONSTANT.BOOKING_MODE[item]
        tempBookingArr.push(type)
      });
      if (this.FTLSurface) {
        for (var i = 0; i < this.FTLServiceArray.length; i++) {
          if (tempBookingArr.length > 0) {
            this.accordiandata.push({
              key:"FTLSurface"+this.FTLServiceArray[i],
              loadtype: "FTL",
              routemode: "Surface",
              servicetype: this.FTLServiceArray[i],
              bokkingtype: tempBookingArr
            })
          }
        }
        for (var k in this.ftlObject) {
          let found = false;
          this.accordiandata.forEach((el)=>{
            if(el.key == k){
              found = true;
            }
          })
          if(found){
            console.log("found")
            this.isServiceSelected = true
            this.ftlObject[k].isSelected = true
            this.ftlObject[k].combination.bookingtype = this.FTLBookingArray
          } else {
            console.log("not found")
            this.ftlObject[k].isSelected = false
          }
        }
      } else {
        this.FTLBookingArray = []
      }
    },
    createAccordianDataForPTL() {
      this.accordiandata = []
      let tempSurfBookingArr = []
      this.PTLSurfBookingArray.forEach((item) => {
        let type = CONSTANT.BOOKING_MODE[item]
        tempSurfBookingArr.push(type)
      });
      if (this.PTLSurface) {
        for (var i = 0; i < this.PTLSurfServiceArray.length; i++) {
          if (tempSurfBookingArr.length > 0) {
            this.accordiandata.push({
              key:"PTLSurface"+this.PTLSurfServiceArray[i],
              loadtype: "PTL",
              routemode: "Surface",
              servicetype: this.PTLSurfServiceArray[i],
              bokkingtype: tempSurfBookingArr,
            })
          }
        }
      } else {
        this.PTLSurfBookingArray = []
      }
      let tempAirBookingArr = []
      this.PTLAirBookingArray.forEach((item) => {
        let type = CONSTANT.BOOKING_MODE[item]
        tempAirBookingArr.push(type)
      });
      if (this.PTLAir) {
        for (var i = 0; i < this.PTLAirServiceArray.length; i++) {
          if (tempAirBookingArr.length > 0) {
            this.accordiandata.push({
              key:"PTLAir"+this.PTLAirServiceArray[i],
              loadtype: "PTL",
              routemode: "Air",
              servicetype: this.PTLAirServiceArray[i],
              bokkingtype: tempAirBookingArr
            })
          }
        }
      } else {
        this.PTLAirBookingArray = []
      }
      for (var k in this.ptlObject) {
        let found = false;
        this.accordiandata.forEach((el)=>{
          if(el.key == k){
            found = true;
          }
        })
        if(found){
          this.isServiceSelected = true
          this.ptlObject[k].isSelected = true
          if (k == "PTLSurfaceForward" || k == "PTLSurfaceReverse") {
            this.ptlObject[k].combination.bookingtype = this.PTLSurfBookingArray;
          }
          if (k == "PTLAirForward" || k == "PTLAirReverse") {
            this.ptlObject[k].combination.bookingtype = this.PTLAirBookingArray;
          }

        } else {
          this.ptlObject[k].isSelected = false
        }
      }
    },
    ShowServiceDetails(id,servicekey,servicetype) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = [];
        this.opened.push(id)
      }
      let servicetypezonetozonecitytocity
      if(servicetype=='FTL')
      {
        servicetypezonetozonecitytocity=this.ftlObject[servicekey].servicetypezonetozonecitytocity
      }
      else{
        servicetypezonetozonecitytocity=this.ptlObject[servicekey].servicetypezonetozonecitytocity
      }
     
      this.filterServiceList(servicetypezonetozonecitytocity)
    },
    async selectServiceLevel(event, key) {
      if(this.ftlObject[key]){
        this.serviceLevelIdForFtlDownload = event.id
        this.ftlObject[key].serviceLevel = event;
        this.ftlObject[key].error = "";
        this.ftlObject[key].ischanged = 1;
      }
    },
    async selectPTLServiceLevel(event, key) {
      if(this.ptlObject[key]){
        console.log("got selected ftl Service Level", key);
        this.serviceLevelIdForPtlDownload = event.id
        this.ptlObject[key].serviceLevel = event;
        this.ptlObject[key].error = "";
        this.ptlObject[key].ischanged = 1;
       }
    },
    async getServiceLevelDropdown() {
      try{
        this.isLoading = true;
        let payload = {}
        let result = await MasterService.getServiceLevelDropdown(payload);
        if (result.data.code == 200) {
          for (var j = 0; j < result.data.data.count; j++) {
            if(result.data.data.rows[j].routemode == 'Surface'){
              let isdisabled=false;
              if(result.data.data.rows[j].status == 0){
                 isdisabled=true;
              }
              this.surfServiceLevelList.push({
                label: result.data.data.rows[j].servicelevelname,
                id: result.data.data.rows[j].id,
                isDisabled:isdisabled,
                servicetype: result.data.data.rows[j].servicetype
              })
            }else if (result.data.data.rows[j].routemode == 'Air') {
              let isdisabled=false;
              if(result.data.data.rows[j].status == 0){
                 isdisabled=true;
              }
              this.airServiceLevelList.push({
                label: result.data.data.rows[j].servicelevelname,
                id: result.data.data.rows[j].id,
                isDisabled:isdisabled,
                servicetype: result.data.data.rows[j].servicetype
              })
            }
          }
        }
      this.isLoading = false;
      }catch(err){
        console.log(err);
      }
    },
    async downloadFileForFtl(key,additionalcities) {
      this.LoaderForPrefill = true
      let payload = {
        contractid: this.contractid,
        contractservicesid : this.ftlObject[key].contractservicesid
      }
      if(this.ftlObject[key].servicetypezonetozonecitytocity==2 && additionalcities!=1)
      {
        payload.servicetype=this.ftlObject[key].servicetypezonetozonecitytocity
      }
      else{
        payload.servicetype=1
      }
      let result;
      let resultArr = [];
      if (this.ftlObject[key].ischanged == 1) {
        let servicepayload = {
        servicelevelid: this.ftlObject[key].serviceLevel.id
      }
      let countResult = await MasterService.getServiceLevelCount(servicepayload);
           let count = Number(countResult.data.data);
           let limit = 30000;
           let offset = 0;
           let tatlist = [];
           let loop =  Math.ceil(count / limit);
           for (let i = 0; i < loop; i++) {
            servicepayload.limit = limit;
            servicepayload.offset = offset;
             result = await MasterService.getServiceLevelDetail(servicepayload);
             resultArr = resultArr.concat(result.data.data.rows)  
             offset = offset + limit;
                 }   
      
     }else{
       if (this.callingFromClientContract && this.callingFromClientContract.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
         if (this.callingFromClientContract.newlySelectedTemplateId && !this.contractidd) {
           let countResult = await MasterService.getContractMasterServicesDetailsCount(payload);
           let count = Number(countResult.data.data);
           let limit = 30000;
           let offset = 0;
           let tatlist = [];
           let loop =  Math.ceil(count / limit);
           for (let i = 0; i < loop; i++) {
             payload.limit = limit;
             payload.offset = offset;
             result = await MasterService.getContractMasterServicesDetailsforDownload(payload);
             resultArr = resultArr.concat(result.data.data)  
             offset = offset + limit;
                 }   
         }
         else if (this.callingFromClientContract.existingContractTemplateId || this.contractidd) {
           payload.contractid =  this.callingFromClientContract.id
           let countResult = await ClientService.getClientServicesDetailsCount(payload);
           let count = Number(countResult.data.data);
           let limit = 30000;
           let offset = 0;
           let tatlist = [];
           let loop =  Math.ceil(count / limit);
           for (let i = 0; i < loop; i++) {
             payload.limit = limit;
             payload.offset = offset;
             result = await ClientService.getClientServicesDetailsforDownload(payload);
             resultArr = resultArr.concat(result.data.data)  
             offset = offset + limit;
                 }    
           // result = await ClientService.getClientServicesDetailsforDownload(payload)
       }
       }
       else {
         let countResult = await MasterService.getContractMasterServicesDetailsCount(payload);
           let count = Number(countResult.data.data);
           let limit = 30000;
           let offset = 0;
           let tatlist = [];
           let loop =  Math.ceil(count / limit);
           for (let i = 0; i < loop; i++) {
             payload.limit = limit;
             payload.offset = offset;
             result = await MasterService.getContractMasterServicesDetailsforDownload(payload);
             resultArr = resultArr.concat(result.data.data)  
             offset = offset + limit;
                 }   
         // result = await MasterService.getContractMasterServicesDetailsforDownload(payload)
       }
     }
        if (resultArr.length > 0) {
          this.LoaderForPrefill = false
          let downloadArr=[]
          if( this.ftlObject[key].servicetypezonetozonecitytocity==2 && additionalcities!=1)                             //mastedata
          {

           downloadArr = this.createMatrixforZonetoZone(resultArr)              //mastedata
          }
          else{
           downloadArr = resultArr.map((el)=>{
            return {
               "Origin Region":el.originregion,
               "Origin State":el.originstate,
               "Origin State Id":el.originstateid,
               "Origin City":el.origincity,
               "Origin City Id":el.origincityid,
               "Destination Region":el.destinationregion,
               "Destination State":el.destinationstate,
               "Destination State Id":el.destinationstateid,
               "Destination City":el.destinationcity,
               "Destination City Id":el.destinationcityid,
               "Route Mode" :el.travelmode,
               "E2E TAT":parseInt(el.tat),
            }
          });
        downloadArr.forEach(function(v){
          delete v['Origin City Id']
          delete v['Origin State Id']
          delete v['Destination City Id']
          delete v['Destination State Id']
        });
      }
        var blob = new Blob([Papa.unparse(downloadArr)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'SalesTAT.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        //  this.getSelectedTemplateInfo(result.data.data.rows, key)
        } else {
          this.$alertify.error("Data Not Found")
        }
    },
    async downloadFileForPtl(key,additionalcities) {
      this.LoaderForPrefill = true
      let payload = {
        contractid: this.contractid,
        contractservicesid : this.ptlObject[key].contractservicesid
      }
      if(this.ptlObject[key].servicetypezonetozonecitytocity==2 && additionalcities!=1)
      {
        payload.servicetype=this.ptlObject[key].servicetypezonetozonecitytocity
      }
      else{
        payload.servicetype=1
      }
      let result;
      let resultArr= [];
      if (this.ptlObject[key].ischanged == 1 && this.ptlObject[key].serviceLevel.id) {
         let servicepayload = {
         servicelevelid: this.ptlObject[key].serviceLevel.id
       }
       let countResult = await MasterService.getServiceLevelCount(servicepayload);
            let count = Number(countResult.data.data);
            let limit = 30000;
            let offset = 0;
            let tatlist = [];
            let loop =  Math.ceil(count / limit);
            for (let i = 0; i < loop; i++) {
              servicepayload.limit = limit;
              servicepayload.offset = offset;
              result = await MasterService.getServiceLevelDetail(servicepayload);
              resultArr = resultArr.concat(result.data.data.rows)  
              offset = offset + limit;
                  }   
       
      }else{
        if (this.callingFromClientContract && this.callingFromClientContract.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
          if (this.callingFromClientContract.newlySelectedTemplateId && !this.contractidd) {
            let countResult = await MasterService.getContractMasterServicesDetailsCount(payload);
            let count = Number(countResult.data.data);
            let limit = 30000;
            let offset = 0;
            let tatlist = [];
            let loop =  Math.ceil(count / limit);
            for (let i = 0; i < loop; i++) {
              payload.limit = limit;
              payload.offset = offset;
              result = await MasterService.getContractMasterServicesDetailsforDownload(payload);
              resultArr = resultArr.concat(result.data.data)  
              offset = offset + limit;
                  }   
          }
          else if (this.callingFromClientContract.existingContractTemplateId || this.contractidd) {
            payload.contractid =  this.callingFromClientContract.id
            let countResult = await ClientService.getClientServicesDetailsCount(payload);
            let count = Number(countResult.data.data);
            let limit = 30000;
            let offset = 0;
            let tatlist = [];
            let loop =  Math.ceil(count / limit);
            for (let i = 0; i < loop; i++) {
              payload.limit = limit;
              payload.offset = offset;
              result = await ClientService.getClientServicesDetailsforDownload(payload);
              resultArr = resultArr.concat(result.data.data)  
              offset = offset + limit;
                  }    
            // result = await ClientService.getClientServicesDetailsforDownload(payload)
        }
        }
        else {
          let countResult = await MasterService.getContractMasterServicesDetailsCount(payload);
            let count = Number(countResult.data.data);
            let limit = 30000;
            let offset = 0;
            let tatlist = [];
            let loop =  Math.ceil(count / limit);
            for (let i = 0; i < loop; i++) {
              payload.limit = limit;
              payload.offset = offset;
              result = await MasterService.getContractMasterServicesDetailsforDownload(payload);
              resultArr = resultArr.concat(result.data.data)  
              offset = offset + limit;
                  }   
          // result = await MasterService.getContractMasterServicesDetailsforDownload(payload)
        }
      }
      
        if (resultArr.length > 0) {
          this.LoaderForPrefill = false
          let downloadArr=[]
          if( this.ptlObject[key].servicetypezonetozonecitytocity==2 && additionalcities!=1 )                             //mastedata
          {
           downloadArr = this.createMatrixforZonetoZone(resultArr)              //mastedata
          }
          else{
             downloadArr = resultArr.map((el)=>{
            return {
               "Origin Region":el.originregion,
               "Origin State":el.originstate,
               "Origin State Id":el.originstateid,
               "Origin City":el.origincity,
               "Origin City Id":el.origincityid,
               "Destination Region":el.destinationregion,
               "Destination State":el.destinationstate,
               "Destination State Id":el.destinationstateid,
               "Destination City":el.destinationcity,
               "Destination City Id":el.destinationcityid,
               "Route Mode" :el.travelmode,
               "E2E TAT":parseInt(el.tat),
            }
          });
        downloadArr.forEach(function(v){
          delete v['Origin City Id']
          delete v['Origin State Id']
          delete v['Destination City Id']
          delete v['Destination State Id']
        });
      }
        var blob = new Blob([Papa.unparse(downloadArr)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'SalesTAT.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        //  this.getSelectedTemplateInfo(result.data.data.rows, key)
        } else {
          this.$alertify.error("Data Not Found")
        }
  },
  async saveContractServices(buttonclick) {
      var contractmasterservices = [];
      var ftlservices = [];
      var ptlservices = [];
      this.ptlerror = null;
      this.ftlerror = null;
      for (var key in this.ftlObject) {
        if(this.ftlObject[key].isSelected){
          let copyCombination = JSON.parse(JSON.stringify(this.ftlObject[key].combination))
          ftlservices.push(copyCombination);
          copyCombination.status = 1;
          copyCombination.UpdateSalesTatType = this.ftlObject[key].UpdateSalesTatType;
          copyCombination.ischanged = this.ftlObject[key].ischanged;
          if (this.ftlObject[key].servicetypezonetozonecitytocity==1) {
            copyCombination.serviceareatype=1
          if (this.ftlObject[key].UpdateSalesTatType == "ServiceLevelTemplate" && !this.ftlObject[key].serviceLevel.id) {
            this.ftlerror = 'validation error';
            this.ftlObject[key].error = "Please select service level";
          }else if (this.ftlObject[key].UpdateSalesTatType == "FileUpload" && this.ftlObject[key].isupload==0 && this.ftlObject[key].ischanged==1) {
            this.ftlerror = 'validation error';
            this.ftlObject[key].error = "Please upload sales tat file";
          }else if (this.ftlObject[key].UpdateSalesTatType == "FileUpload" && this.ftlObject[key].isvalidated==0 && this.ftlObject[key].ischanged==1) {
            this.ftlerror = 'validation error';
            this.ftlObject[key].error = "Please validate uploaded sales tat file";
          }else if (this.ftlObject[key].UpdateSalesTatType == "FileUpload" && this.ftlObject[key].invaliddatacount>0 && this.ftlObject[key].ischanged==1) {
            this.ftlerror = 'validation error';
            this.ftlObject[key].error = "Invalid tat records exists. Please correct it and reupload and validate file again.";
          }else if (this.ftlObject[key].UpdateSalesTatType == "ServiceLevelTemplate" && this.ftlObject[key].ischanged==1) {
            copyCombination.servicelevelid = this.ftlObject[key].serviceLevel.id;
          }else if (this.ftlObject[key].UpdateSalesTatType == "FileUpload" && this.ftlObject[key].ischanged==1) {
            copyCombination.userreferencestring = this.ftlObject[key].userreferencestring;
            copyCombination.userid = this.userid;
            this.ftlerror = "";
            this.ftlObject[key].error = "";
          }
        }
        else{
               copyCombination.serviceareatype=2
            if (this.ftlObject[key].UpdateSalesTatType == "ServiceLevelTemplate" && !this.ftlObject[key].serviceLevel.id) {
              this.ftlerror = 'validation zone to zone error';
              this.ftlObject[key].errorzonetozone  = "Please select zone to zone service level";
            }else if (this.ftlObject[key].UpdateSalesTatType == "FileUpload" && this.ftlObject[key].isuploadzonetozone==0 && this.ftlObject[key].ischanged==1) {
              this.ftlerror = 'validation zone to zone error';
              this.ftlObject[key].errorzonetozone  = "Please upload zone to zone sales tat file";
            }else if (this.ftlObject[key].UpdateSalesTatType == "FileUpload" && this.ftlObject[key].isvalidatedzonetozone==0 && this.ftlObject[key].ischanged==1) {
              this.ftlerror = 'validation zone to zone error';
              this.ftlObject[key].errorzonetozone  = "Please validate uploaded zone to zone sales tat file";
            }else if (this.ftlObject[key].UpdateSalesTatType == "FileUpload" && this.ftlObject[key].invaliddatacountzonetozone>0 && this.ftlObject[key].ischanged==1) {
              this.ftlerror = 'validation zone to zone error';
              this.ftlObject[key].errorzonetozone = "Invalid tat records exists. Please correct it and reupload and validate zone to zone file again.";
            }else if (this.ftlObject[key].UpdateSalesTatType == "ServiceLevelTemplate" && this.ftlObject[key].ischanged==1) {
              copyCombination.servicelevelid = this.ftlObject[key].serviceLevel.id;
            }else if (this.ftlObject[key].UpdateSalesTatType == "FileUpload" && this.ftlObject[key].ischanged==1) {
              copyCombination.userreferencestring = this.ftlObject[key].userreferencestring;
              copyCombination.userid = this.userid;
              this.ftlerror = "";
              this.ftlObject[key].errorzonetozone  = "";
            }
            if (this.ftlObject[key].uploadadditionalcities==true  && this.ftlObject[key].ischanged==1 ) {
              if ( this.ftlObject[key].isupload==0   && this.ftlObject[key].ischanged==1) {
                this.ftlerror = 'validation additional cities error';
                this.ftlObject[key].error = "Please upload sales tat file for additional cities";
              }else if ( this.ftlObject[key].isvalidated==0  && this.ftlObject[key].ischanged==1 ) {
                this.ftlerror = 'validation additional cities error';
                this.ftlObject[key].error = "Please validate uploaded sales tat file";
              }else if ( this.ftlObject[key].invaliddatacount>0 && this.ftlObject[key].ischanged==1) {
                this.ftlerror = 'validation additional cities error';
                this.ftlObject[key].error = "Invalid tat records exists. Please correct it and reupload and validate additional cities file again.";
              }
              else if ( this.ftlObject[key].isvalidated==1 &&   this.ftlObject[key].errorzonetozone  == "") {
                copyCombination.userreferencestring = this.ftlObject[key].userreferencestring;
                copyCombination.userid = this.userid;
                this.ftlerror = "";
                this.ftlObject[key].error = "";
              }
            }
        }
          contractmasterservices.push(copyCombination);
        }
      }
      for (let key in this.ptlObject) {
        if(this.ptlObject[key].isSelected){
          let copyCombination = JSON.parse(JSON.stringify(this.ptlObject[key].combination))
          ptlservices.push(copyCombination);
          copyCombination.status = 1;
          copyCombination.UpdateSalesTatType = this.ptlObject[key].UpdateSalesTatType;
          copyCombination.ischanged = this.ptlObject[key].ischanged;
          if (this.ptlObject[key].servicetypezonetozonecitytocity==1) {
            copyCombination.serviceareatype=1
          if (this.ptlObject[key].UpdateSalesTatType == "ServiceLevelTemplate" && !this.ptlObject[key].serviceLevel.id) {
            this.ptlerror = 'validation error';
            this.ptlObject[key].error = "Please select service level";
          }else if (this.ptlObject[key].UpdateSalesTatType == "FileUpload" && this.ptlObject[key].isupload==0 && this.ptlObject[key].ischanged==1) {
            this.ptlerror = 'validation error';
            this.ptlObject[key].error = "Please upload sales tat file";
          }else if (this.ptlObject[key].UpdateSalesTatType == "FileUpload" && this.ptlObject[key].isvalidated==0 && this.ptlObject[key].ischanged==1) {
            this.ptlerror = 'validation error';
            this.ptlObject[key].error = "Please validate uploaded sales tat file";
          }else if (this.ptlObject[key].UpdateSalesTatType == "FileUpload" && this.ptlObject[key].invaliddatacount>0 && this.ptlObject[key].ischanged==1) {
            this.ptlerror = 'validation error';
            this.ptlObject[key].error = "Invalid tat records exists. Please correct it and reupload and validate file again.";
          }else if (this.ptlObject[key].UpdateSalesTatType == "ServiceLevelTemplate" && this.ptlObject[key].ischanged==1) {
            copyCombination.servicelevelid = this.ptlObject[key].serviceLevel.id
          }else if (this.ptlObject[key].UpdateSalesTatType == "FileUpload" && this.ptlObject[key].ischanged==1) {
            copyCombination.userreferencestring = this.ptlObject[key].userreferencestring;
            copyCombination.userid = this.userid;
            this.ptlerror = "";
            this.ptlObject[key].error = "";
          }
        }
        else{
               copyCombination.serviceareatype=2
            if (this.ptlObject[key].UpdateSalesTatType == "ServiceLevelTemplate" && !this.ptlObject[key].serviceLevel.id) {
              this.ptlerror = 'validation zone to zone error';
              this.ptlObject[key].errorzonetozone  = "Please select zone to zone service level";
            }else if (this.ptlObject[key].UpdateSalesTatType == "FileUpload" && this.ptlObject[key].isuploadzonetozone==0 && this.ptlObject[key].ischanged==1) {
              this.ptlerror = 'validation zone to zone error';
              this.ptlObject[key].errorzonetozone  = "Please upload zone to zone sales tat file";
            }else if (this.ptlObject[key].UpdateSalesTatType == "FileUpload" && this.ptlObject[key].isvalidatedzonetozone==0 && this.ptlObject[key].ischanged==1) {
              this.ptlerror = 'validation zone to zone error';
              this.ptlObject[key].errorzonetozone  = "Please validate uploaded zone to zone sales tat file";
            }else if (this.ptlObject[key].UpdateSalesTatType == "FileUpload" && this.ptlObject[key].invaliddatacountzonetozone>0 && this.ptlObject[key].ischanged==1) {
              this.ptlerror = 'validation zone to zone error';
              this.ptlObject[key].errorzonetozone = "Invalid tat records exists. Please correct it and reupload and validate zone to zone file again.";
            }else if (this.ptlObject[key].UpdateSalesTatType == "ServiceLevelTemplate" && this.ptlObject[key].ischanged==1) {
              copyCombination.servicelevelid = this.ptlObject[key].serviceLevel.id;
            }else if (this.ptlObject[key].UpdateSalesTatType == "FileUpload" && this.ptlObject[key].ischanged==1) {
              copyCombination.userreferencestring = this.ptlObject[key].userreferencestring;
              copyCombination.userid = this.userid;
              this.ptlerror = "";
              this.ptlObject[key].errorzonetozone  = "";
            }
            if (this.ptlObject[key].uploadadditionalcities==true  && this.ptlObject[key].ischanged==1 ) {
              if ( this.ptlObject[key].isupload==0   && this.ptlObject[key].ischanged==1) {
                this.ptlerror = 'validation additional cities error';
                this.ptlObject[key].error = "Please upload sales tat file for additional cities";
              }else if ( this.ptlObject[key].isvalidated==0  && this.ptlObject[key].ischanged==1 ) {
                this.ptlerror = 'validation additional cities error';
                this.ptlObject[key].error = "Please validate uploaded sales tat file";
              }else if ( this.ptlObject[key].invaliddatacount>0 && this.ptlObject[key].ischanged==1) {
                this.ptlerror = 'validation additional cities error';
                this.ptlObject[key].error = "Invalid tat records exists. Please correct it and reupload and validate additional cities file again.";
              }
              else if ( this.ptlObject[key].isvalidated==1 &&  this.ptlObject[key].errorzonetozone  =="" ) {
                copyCombination.userreferencestring = this.ptlObject[key].userreferencestring;
                copyCombination.userid = this.userid;
                this.ptlerror = "";
                this.ptlObject[key].error = "";
              }
            }
        }
          contractmasterservices.push(copyCombination);
        }
      }
      if (this.ptlerror || this.ftlerror) {
        if(this.loadtab == "FTL" && this.ftlerror == null && this.ptlerror){
          this.$alert("Please select/upload service level for selected PTL services", "", "error");
        }
        if(this.loadtab == "PTL" && this.ptlerror == null && this.ftlerror){
          this.$alert("Please select/upload service level for selected FTL services", "", "error");
        }
        return false;
      }
      if(contractmasterservices.length < 1){
        this.$alert("Please select atleast one service", "", "error");
        return false;
      }
      var input = {
        contractid: 0,
        ftlservices: ftlservices,
        ptlservices: ptlservices,
        createdby: this.userName,
        status: 1,
        contractmasterservices: contractmasterservices
      }
      if (this.actionType == "EDIT") {
        input.contractid = this.contractid
      }
      console.log("input",input);
      this.$emit("goBackToCreateContract", input, buttonclick);
    },
    getContractIDFromTemplate1(contractid, buttonclick) {
      this.contractid = contractid
    },
    async chooseFileZonetoZone(e,servicetype,servicekey){
      try {
        this.isinvalid=false
        if(servicetype=="ftl"){
          this.ftlObject[servicekey].isuploadzonetozone = 0;
          this.ftlObject[servicekey].ischanged = 1;
          this.ftlObject[servicekey].isvalidatedzonetozone = 0;
          this.ftlObject[servicekey].showSalesTatDownloadzonetozone= false;
          this.ftlObject[servicekey].errorzonetozone = "";
        }else{
          this.ptlObject[servicekey].isuploadzonetozone = 0;
          this.ptlObject[servicekey].ischanged= 1;
          this.ptlObject[servicekey].isvalidatedzonetozone= 0;
          this.ptlObject[servicekey].showSalesTatDownloadzonetozone = false;
          this.ptlObject[servicekey].errorzonetozone = "";
        }
        const files = e.target.files;
        if (!files.length) {
          this.$refs.files.value=null;
          return;
        } else if (!/\.(csv)$/.test(files[0].name.toLowerCase())) {
          this.$refs.files.value=null;
          return this.$alert('The upload format is incorrect. Please upload csv format', "", "error");
        }else{
          if(servicetype=="ftl"){
            this.ftlObject[servicekey].filenamezonetozone = e.target.files[0].name;
          }else{
            this.ptlObject[servicekey].filenamezonetozone = e.target.files[0].name;
          }
            await this.parse18x18File(servicetype,servicekey,e.target.files[0]);  
        }
      } catch(err){
        this.isLoading = false;
      }
    },
     async parse18x18File(servicetype,servicekey,filedata){
      let tempArr = []
      let tempArrforValidation=[]
      let userid = this.userid;
      let userreferencestring = this.userreferencestring+servicekey;
      Papa.parse(filedata, {
        header: true, // Assumes the first row contains column headers
        dynamicTyping: true, // Automatically convert values to their appropriate types
        before: this.isLoading = true,
        skipEmptyLines: true,
        complete: function (result) {
          let data = result.data;
          // Create an object to store the JSON data
          // Iterate through the rows and columns to create the JSON
          if (data.length>18) {
            this.isinvalid=true
            if(servicetype=="ftl"){
              this.ftlObject[servicekey].filenamezonetozone = null;
              this.ftlObject[servicekey].isuploadzonetozone=0
            }else{
              this.ptlObject[servicekey].filenamezonetozone = null;
              this.ptlObject[servicekey].isuploadzonetozone=0
            }
           return this.$alert('Invalid 18 x18 template :File headers mismached Origin Zones shold be maximum 18', "", "error");
              }
          let duplicaterow = this.hasDuplicateEmptyValues(data)
          if (duplicaterow) {
            this.isinvalid=true
            return this.$alert('File headers are duplicate. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
          }
          for (let i = 0; i < data.length; i++) {
            let row = data[i];
            let rowName = row['']; // Row name is in the first column
             if(Object.keys(row).length>19)
               {
                this.isinvalid=true
                if(servicetype=="ftl"){
                  this.ftlObject[servicekey].filenamezonetozone = null;
                  this.ftlObject[servicekey].isuploadzonetozone = 0;
                }else{
                  this.ptlObject[servicekey].filenamezonetozone = null;
                  this.ptlObject[servicekey].isuploadzonetozone = 0;
                }
                return this.$alert('Invalid 18 x18 template :File headers mismached Destination Zones shold be maximum 18', "", "error");
               }
             if(Object.keys(row)[0] )
               {
                 this.isLoading = false
                 this.isinvalid=true
                 if(servicetype=="ftl"){
                  this.ftlObject[servicekey].filenamezonetozone = null;
                  this.ftlObject[servicekey].isuploadzonetozone=0
                }else{
                  this.ptlObject[servicekey].filenamezonetozone = null;
                  this.ptlObject[servicekey].isuploadzonetozone=0
                }
                 return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
               }
             if(  !this.zones.includes(rowName))
               {
                 this.isLoading = false
                 this.isinvalid=true
                 if(servicetype=="ftl"){
                  this.ftlObject[servicekey].filenamezonetozone = null;
                  this.ftlObject[servicekey].isuploadzonetozone=0
                }else{
                  this.ptlObject[servicekey].filenamezonetozone = null;
                  this.ptlObject[servicekey].isuploadzonetozone=0
                }
                 return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
               }
            for (const colName in row) {
            const keysArray = Object.keys(row);
            if( keysArray.indexOf(colName)!=0 && !this.zones.includes(colName))
              {
               this.isLoading = false
               this.isinvalid=true
               if(servicetype=="ftl"){
                this.ftlObject[servicekey].filenamezonetozone = null;
                this.ftlObject[servicekey].isuploadzonetozone=0
              }else{
                this.ptlObject[servicekey].filenamezonetozone = null;
                this.ptlObject[key].isuploadzonetozone=0
              }
               return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
              }
              if (colName !== '' && row[colName]!= null) {
                let zoneName = colName;
                tempArr.push({origincity : rowName , destinationcity :zoneName , feedertat : row[colName] ,servicetype:2,userreferencestring:userreferencestring,userid:userid})
                tempArrforValidation.push({originzone : rowName , destinationzone :zoneName , TAT : row[colName] ,servicetype:2})
              }
            }
          }
      if(this.isinvalid==false)
      {
      this.chunkArrayZonetoZone(tempArr, 20000,userreferencestring);
      if(servicetype=="ftl"){
        this.ftlObject[servicekey].totalrecordszonetozone = tempArr.length;
        this.ftlObject[servicekey].isuploadzonetozone = 1;
        this.ftlObject[servicekey].isvalidatedzonetozone = 0;
      }else{
        this.ptlObject[servicekey].totalrecordszonetozone = tempArr.length;
        this.ptlObject[servicekey].isuploadzonetozone = 1;
        this.ptlObject[servicekey].isvalidatedzonetozone = 0;
      }
      this.arrOfMatrix = tempArrforValidation
      this.isLoading = false 
    }
    else{
      this.ftlObject[servicekey].isuploadzonetozone = 0;
      this.isLoading = false
    }
    }.bind(this)
    });
    this.isLoading = false
    },
    async chunkArrayZonetoZone(myArray, chunk_size,userreferencestring){
      try {
        console.log("Start Time", Date() );
        await this.deletePreviousUploadSalesTAT(userreferencestring,2);
        var index = 0;
        var arrayLength = myArray.length;
        let tempArr = [];
        for (index = 0; index < arrayLength; index += chunk_size) {
            let myChunk = myArray.slice(index, index+chunk_size);
            await this.uploadSalesFile(myChunk, index);
        }
        console.log("End Time", Date() );
        this.$alertify.success("File data uploaded Successfully");
        this.isLoading = false;
      }catch (err){
        console.log(err);
      }
    },
    async validateFileZoneToZone(servicetype,servicekey){
      try {
        if(servicetype=='ftl')
        {
          this.ftlObject[servicekey].tableItems=[]
          this.isLoading = true;
          var inputPayload = {};
          inputPayload.arrOfMatrix = this.arrOfMatrix;
          inputPayload.userid=this.userid
          inputPayload.userreferencestring=this.userreferencestring+servicekey
          inputPayload.servicetype=this.ftlObject[servicekey].servicetypezonetozonecitytocity
          this.ftlObject[servicekey].totalrecordszonetozone = this.arrOfMatrix.length;
          let result = await MasterService.validateSalesTAT18x18(inputPayload);
          this.isupload = 1
          this.isLoading = false;
          if (result.data.code == 409) {
            this.ftlObject[servicekey].totalCountzonetozone = result.data.data.length;
            this.ftlObject[servicekey].totalPagezonetozone = Math.ceil(this.ftlObject[servicekey].totalCount/this.ftlObject[servicekey].pageLimit);
            this.ftlObject[servicekey].tableItemszonetozone = result.data.data.map((el,index)=>{
              return {
                 'id':index+1,
                'Origin Zone':el.originzone,
                'Destination Zone':el.destinationzone,
                'TAT': el.TAT,
                'Invalid Reason': el.msg,
              }
            });
            this.ftlObject[servicekey].isvalidatedzonetozone = 1;
            this.ftlObject[servicekey].invalid18x18Data = result.data.data
            this.ftlObject[servicekey].validdatacountzonetozone=this.ftlObject[servicekey].totalrecordszonetozone- this.ftlObject[servicekey].invalid18x18Data.length
            this.ftlObject[servicekey].invaliddatacountzonetozone = this.ftlObject[servicekey].invalid18x18Data.length
            this.ftlObject[servicekey].validdatacountzonetozone = this.ftlObject[servicekey].totalrecordszonetozone - this.ftlObject[servicekey].invaliddatacountzonetozone
            this.ftlObject[servicekey].userreferencestring = this.userreferencestring+servicekey;
            this.ftlObject[servicekey].errorzonetozone = "";
          }else{
            let payload={}
            payload.userreferencestring = this.userreferencestring+servicekey
            payload.userid=this.userid
            payload.servicetype=2
            this.ftlObject[servicekey].isvalidatedzonetozone = 1;
            this.ftlObject[servicekey].invalid18x18Data =0
            this.ftlObject[servicekey].invaliddatacountzonetozone = 0
            this.ftlObject[servicekey].validdatacountzonetozone = this.ftlObject[servicekey].totalrecordszonetozone - this.ftlObject[servicekey].invaliddatacountzonetozone
            this.ftlObject[servicekey].userreferencestring = this.userreferencestring+servicekey;
            this.ftlObject[servicekey].errorzonetozone = "";
            this.$alert(result.data.message, "", "success");
          }
          this.ftlObject[servicekey].isvalidatedzonetozone=1
        }
        else  if(servicetype=='ptl')
        {
          this.ptlObject[servicekey].tableItems=[]
          this.isLoading = true;
          var inputPayload = {};
          inputPayload.arrOfMatrix = this.arrOfMatrix;
         
          this.ptlObject[servicekey].totalrecordszonetozone = this.arrOfMatrix.length;
           inputPayload.userreferencestring = this.userreferencestring+servicekey
           inputPayload.userid=this.userid
           inputPayload.servicetype=2
          let result = await MasterService.validateSalesTAT18x18(inputPayload);
          this.isupload = 1
          this.isLoading = false;
          if (result.data.code == 409) {
            this.ptlObject[servicekey].totalCountzonetozone = result.data.data.length;
            this.ptlObject[servicekey].totalPagezonetozone = Math.ceil(this.ptlObject[servicekey].totalCount/this.ptlObject[servicekey].pageLimit);
            this.ptlObject[servicekey].tableItemszonetozone = result.data.data.map((el,index)=>{
              return {
                 'id':index+1,
                'Origin Zone':el.originzone,
                'Destination Zone':el.destinationzone,
                'TAT': el.TAT,
                'Invalid Reason': el.msg,
              }
            });
            this.ptlObject[servicekey].isvalidatedzonetozone = 1;
            this.ptlObject[servicekey].invalid18x18Data = result.data.data
            this.ptlObject[servicekey].validdatacountzonetozone=this.ptlObject[servicekey].totalrecordszonetozone- this.ptlObject[servicekey].invalid18x18Data.length
            this.ptlObject[servicekey].invaliddatacountzonetozone = this.ptlObject[servicekey].invalid18x18Data.length
            this.ptlObject[servicekey].validdatacountzonetozone = this.ptlObject[servicekey].totalrecordszonetozone - this.ptlObject[servicekey].invaliddatacountzonetozone
            this.ptlObject[servicekey].userreferencestring = this.userreferencestring+servicekey;
            this.ptlObject[servicekey].errorzonetozone = "";
          }else{
            this.ptlObject[servicekey].isvalidatedzonetozone = 1;
            this.ptlObject[servicekey].invalid18x18Data =0
            this.ptlObject[servicekey].invaliddatacountzonetozone = 0
            this.ptlObject[servicekey].validdatacountzonetozone = this.ptlObject[servicekey].totalrecordszonetozone - this.ptlObject[servicekey].invaliddatacountzonetozone
            this.ptlObject[servicekey].userreferencestring = this.userreferencestring+servicekey;
            this.ptlObject[servicekey].errorzonetozone = "";
            this.$alert(result.data.message, "", "success");
          }
          this.ptlObject[servicekey].isvalidatedzonetozone=1
        }
       
      } catch(err){
        console.log("_+_+_",err);
        this.isLoading = false;
      }
    },
    createMatrixforZonetoZone(data) {
			// Define the list of zones and initialize an empty matrix
			const matrix = {};
			// Initialize the matrix with zeros
			const matrixArray = this.zones.map((origin) => {
			  const row = { '': origin };
			  this.zones.forEach((destination) => {
				const foundItem = data.find(item => item.origincity === origin && item.destinationcity === destination);
				row[destination] = foundItem ? foundItem.tat: null;
			  });
			  return row;
			});
			return matrixArray;
		  },
     SelectServiceType(data ,servicetype,servicekey,)
    {
    if(servicetype=='ftl')
    {
    
      let servicetypezonetozonecitytocity=data.id
      this.ftlObject[servicekey].ischanged=1,
      this.resetdataftl(servicekey)
      this.filterServiceList(servicetypezonetozonecitytocity)
    }
    else{
      let servicetypezonetozonecitytocity=data.id
      this.ptlObject[servicekey].ischanged=1,
      this.resetdataptl(servicekey)
      this.filterServiceList(servicetypezonetozonecitytocity)
    }
    let userreferencestring=this.userreferencestring+servicekey
     this.deletePreviousUploadSalesTAT(userreferencestring,null);
     this.isLoading = false;
    },
    resetdataftl(servicekey)
    {
      this.ftlObject[servicekey].serviceLevel={},
      this.ftlObject[servicekey].filename=null,
      this.ftlObject[servicekey].isupload=0,
      this.ftlObject[servicekey].isvalidated=0,
      this.ftlObject[servicekey].val={},
      this.ftlObject[servicekey].serviceLevel={},
      this.ftlObject[servicekey].filename=null,
      this.ftlObject[servicekey].totalrecords=0,
      this.ftlObject[servicekey].validdatacount=0,
      this.ftlObject[servicekey].invaliddatacount=0,
      this.ftlObject[servicekey].tableItems=[],
      this.ftlObject[servicekey].currentPage=1,
      this.ftlObject[servicekey].filenamezonetozone=null,
      this.ftlObject[servicekey].isuploadzonetozone=0,
      this.ftlObject[servicekey].isvalidatedzonetozone=0,
      this.ftlObject[servicekey].totalrecordszonetozone=0,
      this.ftlObject[servicekey].validdatacountzonetozone=0,
      this.ftlObject[servicekey].invaliddatacountzonetozone=0,
      this.ftlObject[servicekey].currentPagezonetozone=1,
      this.ftlObject[servicekey].tableItemszonetozone=[]
 
    },
    resetdataptl(servicekey)
    {
      this.ptlObject[servicekey].serviceLevel={},
      this.ptlObject[servicekey].filename=null,
      this.ptlObject[servicekey].isupload=0,
      this.ptlObject[servicekey].isvalidated=0,
      this.ptlObject[servicekey].val={},
      this.ptlObject[servicekey].serviceLevel={},
      this.ptlObject[servicekey].filename=null,
      this.ptlObject[servicekey].totalrecords=0,
      this.ptlObject[servicekey].validdatacount=0,
      this.ptlObject[servicekey].invaliddatacount=0,
      this.ptlObject[servicekey].tableItems=[],
      this.ptlObject[servicekey].currentPage=1,
      this.ptlObject[servicekey].filenamezonetozone=null,
      this.ptlObject[servicekey].isuploadzonetozone=0,
      this.ptlObject[servicekey].isvalidatedzonetozone=0,
      this.ptlObject[servicekey].totalrecordszonetozone=0,
      this.ptlObject[servicekey].validdatacountzonetozone=0,
      this.ptlObject[servicekey].invaliddatacountzonetozone=0,
      this.ptlObject[servicekey].currentPagezonetozone=1,
      this.ptlObject[servicekey].tableItemszonetozone=[]
 
    },
    changecitytocity(servicekey)
    {
      if (servicekey=="FTLSurfaceForward" && this.ftlObject[servicekey].UpdateSalesTatType=='FileUpload') {
        if (this.ftlObject[servicekey].isuploadzonetozone == 0 ) {
          this.$confirm("Editing exceptional field checkbox will delete any previously uploded records, Do you wish to continue?","","question").then(async () => {
            this.setIsChangedFlag(servicekey)
          }).catch((err)=>{
            this.ftlObject[servicekey].uploadadditionalcities = !this.ftlObject[servicekey].uploadadditionalcities
          console.log(err)
          });
        }else{
          this.setIsChangedFlag(servicekey)
        }
      }else if((servicekey=="PTLSurfaceForward"||servicekey=="PTLAirForward") && this.ptlObject[servicekey].UpdateSalesTatType=='FileUpload'){
        if (this.ptlObject[servicekey].isuploadzonetozone == 0 ) {
          this.$confirm("Editing exceptional field checkbox will delete any previously uploded records, Do you wish to continue?","","question").then(async () => {
            this.setIsChangedFlag(servicekey)
          }).catch((err)=>{
            this.ptlObject[servicekey].uploadadditionalcities = !this.ptlObject[servicekey].uploadadditionalcities
          console.log(err)
          });
        }else{
          this.setIsChangedFlag(servicekey)
        }
      }else{
        this.setIsChangedFlag(servicekey)
      }
    },
    setIsChangedFlag(servicekey){
      if(servicekey=="FTLSurfaceForward")
      {
      this.ftlObject[servicekey].ischanged=1
      }

      else if(servicekey=="PTLSurfaceForward"||servicekey=="PTLAirForward") 
      {
        this.ptlObject[servicekey].ischanged=1
      }
      let userreferencestring=this.userreferencestring+servicekey
      this.deletePreviousUploadSalesTAT(userreferencestring,1);
      this.isLoading = false;
    },
    filterServiceList(servicetypezonetozonecitytocity) {
      this.surfServiceLevelListZonetoZone=[]
      this.surfServiceLevelListCitytoCity=[]
      this.airServiceLevelListZonetoZone=[]
      this.airServiceLevelListCitytoCity=[]
      if(servicetypezonetozonecitytocity==2)
      {
        this.surfServiceLevelList.forEach(item => item.servicetype == servicetypezonetozonecitytocity && this.surfServiceLevelListZonetoZone.push({
          label: item.label,
          id: item.id,
          isDisabled: item.isDisabled 
        }));  
        this.airServiceLevelList.forEach(item => item.servicetype == servicetypezonetozonecitytocity && this.airServiceLevelListZonetoZone.push({
          label: item.label,
          id: item.id,
          isDisabled: item.isDisabled 
        }));  
      }
      else if(servicetypezonetozonecitytocity==1)
      {
      this.surfServiceLevelList.forEach(item => item.servicetype == servicetypezonetozonecitytocity && this.surfServiceLevelListCitytoCity.push({
				label: item.label,
				id: item.id,
				isDisabled: item.isDisabled 
			}));
      this.airServiceLevelList.forEach(item => item.servicetype == servicetypezonetozonecitytocity && this.airServiceLevelListCitytoCity.push({
				label: item.label,
				id: item.id,
				isDisabled: item.isDisabled 
			}));
      }
		},
    async getZonenamesdata() {
      let inputpayload = {}
      let result = await MasterService.GetZoneNames(inputpayload);
      if (result.data.code == 200) {
        this.zones = result.data.data
      }
      else {
        this.$alertify.success("Zones Data not found");
      }
    },
    hasDuplicateEmptyValues(arr) {
      const seenValues = new Set();
    
      for (const obj of arr) {
        const value = obj[""];
    
        if (seenValues.has(value)) {
          // Duplicate value found
          return true;
        } else {
          // Add the value to the set
          seenValues.add(value);
        }
      }
    
      // No duplicate values found
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/Template1/newservices/newservices.component.js